import {RectNode, RectNodeModel} from '@logicflow/core';

class NodeStartModel extends RectNodeModel {
    getNodeStyle() {
        const style = super.getNodeStyle();
        const properties = this.properties;

        style.strokeWidth = 1
        if (properties.finish === true || properties.current === true) {
            style.strokeWidth = 3;
        }

        if (properties.skin_fill) {
            style.fill = properties.skin_fill;
        }

        if (properties.style_fill) {
            style.fill = properties.style_fill
        }

        if (properties.style_stroke) {
            style.stroke = properties.style_stroke
        }

        if (properties.rx) {
            style.rx = properties.rx
        }
        return style;
    }

    getTextStyle() {
        const style = super.getTextStyle();

        const properties = this.properties;
        if (properties.style_color) {
            style.color = properties.style_color
        }
        return style;
    }
}

class PrcRectNode extends RectNode {
}

export default {
    type: 'node_start',
    view: PrcRectNode,
    model: NodeStartModel,
};